var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IQOSTable',{attrs:{"cols":[
      {
          title: 'Дата',
          key: 'created_at',
          date: true
      },
      {
          title: 'Час',
          key: 'created_at',
          time: true
      },
      {
          title: "Ім'я клієнта",
          key: 'name'
      },
      {
          title: 'Телефон клієнта',
          key: 'phone'
      },
      {
          title: 'Приз',
          key: 'prize_name',
          renderer: function (k) { return k.prize_name || '-'; }
      }
  ],"rows":_vm.rolls}})}
var staticRenderFns = []

export { render, staticRenderFns }